import axiosInstance from "@/config/axios";

export const getSOE = async (id: string) => {
	const cleanedId = id.replace(/^"(.+)"$/, "$1");
	console.log("id111111111", cleanedId);
	try {
		const response = await axiosInstance.get(`/companies/${cleanedId}`);
		console.log("response.data", response.data);
		return response.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};

export const putSOE = async (id: string, data: any) => {
	const cleanedId = id.replace(/^"(.+)"$/, "$1");
	try {
		const response = await axiosInstance.put(`/companies/${cleanedId}`, data);
		return response.data;
	} catch (error) {
		console.error("Error updating company data:", error);
		throw error;
	}
};

interface ChildrenParams {
	skip?: number;
	limit?: number;
	companyId: string;
}

export const getChildren = async ({
	skip = 0,
	limit = 10,
	companyId,
}: ChildrenParams) => {
	const cleanedId = companyId.replace(/^"(.+)"$/, "$1");
	try {
		const response = await axiosInstance.get("/companies/children", {
			params: {
				skip,
				limit,
				companyId: cleanedId,
			},
		});
		return response.data;
	} catch (error) {
		console.error("Error fetching children data:", error);
		throw error;
	}
};

interface DirectorsParams {
	skip?: number;
	limit?: number;
	companyId: string;
}

export const getSOEDirectors = async ({
	skip = 0,
	limit = 10,
	companyId,
}: DirectorsParams) => {
	const cleanedId = companyId.replace(/^"(.+)"$/, "$1");
	try {
		const response = await axiosInstance.get("/directors", {
			params: {
				skip,
				limit,
				companyId: cleanedId,
			},
		});
		return response.data;
	} catch (error) {
		console.error("Error fetching directors data:", error);
		throw error;
	}
};
